import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Ellipses from '../../../../../Common/EllipsesControl/EllipsesPresets';

export const BodySpecialAccordionHeaderColumn = ({className, header, value}) => {
	return (
		<StyledBodySpecialAccordionHeaderColumn className={`StyledBodySpecialAccordionHeaderColumn ${className}`}>
			<section className="StyledBodySpecialAccordionHeaderColumnGroup">
				<span className={'body-special-accordion-header-column-header'}>
					<Ellipses.Single>{header}</Ellipses.Single>
				</span>
				<span className={'body-special-accordion-header-column-value'}>
					<Ellipses.Single>{value}</Ellipses.Single>
				</span>
			</section>
		</StyledBodySpecialAccordionHeaderColumn>
	);
};

BodySpecialAccordionHeaderColumn.propTypes = {
	className: PropTypes.string,
	header: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

BodySpecialAccordionHeaderColumn.defaultProps = {
	className: 'body-special-accordion-header-column'
};

export default BodySpecialAccordionHeaderColumn;

const StyledBodySpecialAccordionHeaderColumn = styled.section`
	padding: var(--px-10) var(--px-10) var(--px-10) 0;
	width: calc(100% - var(--px-200));
	.StyledBodySpecialAccordionHeaderColumnGroup {
		width: 100%;
	}
	.body-special-accordion-header-column-header {
		font-size: var(--px-14);
		font-weight: 300;
		line-height: var(--px-20);
	}
	.body-special-accordion-header-column-value {
		display: flex;
		font-size: var(--px-14);
		font-weight: 400;
		line-height: var(--px-20);
	}
`;
